// extracted by mini-css-extract-plugin
export default {"container":"cat_3nOFs","link":"cat_lin_1qkDY"};